<template>
	<div>
		<NcdTopContainer v-if="hasAccess() && !isLaptop" />
		<div
			class="cand-profiledashboard-maincontainer p-3 d-flex mob-top-0"
			:style="(!hasAccess()) ? { top: '80px' } : {}"
		>
			<div
				class="profile-candash-left-container"
				:style="(!hasAccess() && !isLaptop) ? { paddingBottom: '100px' } : {}"
			>
				<div v-if="showTaskBarShimmer">
					<div class="candash-top-header position-relative">
						<div class="candash-profile-pic avatar-class">
							<b-skeleton type="avatar"></b-skeleton>
						</div>
						<div>
							<div>
								<b-skeleton class="ml-3 mt-2 w-25 h-10"></b-skeleton>
							</div>
							<div>
								<b-skeleton class="ml-3 mt-2 w-50 h-10"></b-skeleton>
							</div>
						</div>
					</div>
					<div class="candash-below-header-2">
						<div class="p175 ml-4">
							<b-skeleton class="mt-2 w-75 h-10"></b-skeleton>
						</div>

						<div>
							<b-skeleton class="ml-2 mt-4 w-15 h-10"></b-skeleton>
						</div>
						<div>
							<b-skeleton-img
								no-aspect
								height="60px "
								width="90%"
								class="ml-2 mt-2"
								style="bottom: 3px; border-radius: 5px"
							></b-skeleton-img>
						</div>
					</div>
				</div>

				<!-- shimmer ends -->

				<div
					v-if="!showTaskBarShimmer"
					:class="
						!getDetails.visibilityConfig.personalDetails ? 'card-blur' : ''
					"
				>
					<div
						class="candash-top-header position-relative d-flex align-items-start justify-content-between"
					>
						<div class="candash-profile-pic">
							<img
								v-if="
									!getDetails.image ||
									(getDetails.visibilityConfig.personalDetails_Fields &&
										!getDetails.visibilityConfig.personalDetails_Fields.image)
								"
								:src="staticImageLink"
								class="candash-uploaded"
								alt=""
							/>

							<img
								v-else
								class="candash-uploaded"
								:src="getDetails.image"
								alt=""
							/>
							<section id="hideinlaptop" class="position-relative">
								<div class="mob-shareicon" ref="qrbutton2">
									<img
										class="pointer"
										@click="openShare()"
										src="@/assets/newdesign/dashboard/publicprofile-share.svg"
										alt=""
									/>
								</div>
								<div
									class="public-sharelink-box"
									v-if="!isLaptop && shareClick && !userInfo.isDisabled"
									ref="expdropdown2"
									v-closable="{
										exclude: ['expdropdown2', 'qrbutton2'],
										handler: 'closeShare',
									}"
								>
									<div
										class="candash-displaytxt-grey-2 d-flex justify-content-between"
									>
										Copy link to share
										<div v-if="linkCopied">
											<img
												src="@/assets/newdesign/dashboard/greyTick.svg"
												class="mr-1"
											/>
											<span class="copied-link">Copied</span>
										</div>
									</div>
									<div class="mt-2 position-relative">
										<b-form-input
											id="test-link"
											class="sharelink-input"
											v-model="getDetails.link"
											disabled
										>
										</b-form-input>
										<img
											@click="copyTheLink(getDetails.link)"
											class="copy-position"
											src="@/assets/newdesign/dashboard/copyBlue.svg"
											alt=""
										/>
									</div>
									<!-- <div v-if="linkCopied">LinkCopied</div> -->
									<div class="d-flex align-items-center mt-2">
										<div ref="qrCodeContainer" class="qr-code-container mr-2">
											<img
												class="h-100 w-100"
												:src="getDetails.qrCode"
												alt=""
											/>
										</div>
										<div class="candash-displaytxt-grey-3">
											Download and share profile QR
										</div>
										<div>
											<img
												@click="downloadQRCode"
												class="ml-2 pointer"
												src="@/assets/newdesign/dashboard/download2.svg"
												alt=""
											/>
										</div>
									</div>
								</div>
							</section>
						</div>
						<div class="w65">
							<div class="candash-boldWhite">
								<span>
									<span
										v-if="
											getDetails.visibilityConfig.personalDetails_Fields
												.firstName
										"
									>
										{{ getDetails.firstName }}
									</span>
									<span v-else>
										{{ maskName(getDetails.firstName) }}
									</span>
								</span>

								<span
									v-if="
										getDetails.visibilityConfig.personalDetails_Fields.lastName
									"
								>
									{{ getDetails.lastName }}
								</span>
								<span v-else>
									{{ maskName(getDetails.lastName) }}
								</span>
							</div>

							<div
								v-if="getDetails.experienceLevel == 'fresher' || 
									getDetails.experienceLevel == 'student' ||
									getDetails.experienceLevel == 'intermediate' ||
									getDetails.experienceLevel == 'senior'"
								class="candash-normaltxt"
							>
								<span
									v-if="
										getDetails.designation && getDetails.totalYearsOfExp
									"
								>
									{{
										maskText(
											getDetails.designation,
											getDetails.visibilityConfig.personalDetails_Fields
												.designation
										)
									}}
									|
									{{
										maskExperience(
											getDetails.totalYearsOfExp,
											getDetails.visibilityConfig.personalDetails_Fields
												.totalYearsOfExp
										)
									}}
									<span v-if="getDetails.totalYearsOfExp == 1">Year</span>
									<span v-else>Years</span>
								</span>

								<span
									v-else-if="
										getDetails.designation && !getDetails.totalYearsOfExp
									"
								>
									{{
										maskText(
											getDetails.designation,
											getDetails.visibilityConfig.personalDetails_Fields
												.designation
										)
									}}
									|
									{{
										maskText(
											capitalizeFirstLetter(
												getDetails.experienceLevelFormatted
											),
											getDetails.visibilityConfig.personalDetails_Fields
												.experienceLevel
										)
									}}
								</span>

								<span v-else-if="getDetails.totalYearsOfExp">
									{{
										maskText(
											capitalizeFirstLetter(
												getDetails.experienceLevelFormatted
											),
											getDetails.visibilityConfig.personalDetails_Fields
												.experienceLevel
										)
									}}
									|
									{{
										maskExperience(
											getDetails.totalYearsOfExp,
											getDetails.visibilityConfig.personalDetails_Fields
												.totalYearsOfExp
										)
									}}
									<span v-if="getDetails.totalYearsOfExp == 1">Year</span>
									<span v-else>Years</span>
								</span>

								<span v-else>
									{{
										maskText(
											capitalizeFirstLetter(
												getDetails.experienceLevelFormatted
											),
											getDetails.visibilityConfig.personalDetails_Fields
												.experienceLevel
										)
									}}
								</span>
							</div>

							<!-- <div
								v-else-if="
									getDetails.experienceLevel == 'intermediate' ||
									getDetails.experienceLevel == 'senior'
								"
								class="candash-normaltxt"
							>
								<span
									v-if="
										getDetails.designation && getDetails.totalYearsOfExp
									"
								>
									{{
										maskText(
											getDetails.designation,
											getDetails.visibilityConfig.personalDetails_Fields
												.designation
										)
									}}
									|
									{{
										maskExperience(
											getDetails.totalYearsOfExp,
											getDetails.visibilityConfig.personalDetails_Fields
												.totalYearsOfExp
										)
									}}
									<span v-if="getDetails.totalYearsOfExp == 1">Year</span>
									<span v-else>Years</span>
								</span>

								<span v-else-if="getDetails.totalYearsOfExp">
									{{
										maskText(
											capitalizeFirstLetter(
												getDetails.experienceLevelFormatted
											),
											getDetails.visibilityConfig.personalDetails_Fields
												.experienceLevel
										)
									}}
									|
									{{
										maskExperience(
											getDetails.totalYearsOfExp,
											getDetails.visibilityConfig.personalDetails_Fields
												.totalYearsOfExp
										)
									}}
									<span v-if="getDetails.totalYearsOfExp == 1">Year</span>
									<span v-else>Years</span>
								</span>
							</div> -->
						</div>
						<div
							id="hideinmobile"
							class="position-relative mob-shareicon"
							ref="qrbutton"
						>
							<img
								class="pointer"
								@click="openShare()"
								src="@/assets/newdesign/dashboard/publicprofile-share.svg"
								alt=""
							/>
						</div>
						<div
							class="public-sharelink-box"
							v-if="isLaptop && shareClick && !userInfo.isDisabled"
							ref="expdropdown"
							v-closable="{
								exclude: ['expdropdown', 'qrbutton'],
								handler: 'closeShare',
							}"
						>
							<div
								class="candash-displaytxt-grey-2 d-flex justify-content-between"
							>
								Copy link to share
								<div v-if="linkCopied">
									<img
										src="@/assets/newdesign/dashboard/greyTick.svg"
										class="mr-1"
									/>
									<span class="copied-link">Copied</span>
								</div>
							</div>
							<div class="mt-2 position-relative">
								<b-form-input
									id="test-link"
									class="sharelink-input"
									v-model="getDetails.link"
									disabled
								>
								</b-form-input>
								<img
									@click="copyTheLink(getDetails.link)"
									class="copy-position"
									src="@/assets/newdesign/dashboard/copyBlue.svg"
									alt=""
								/>
							</div>
							<!-- <div v-if="linkCopied">LinkCopied</div> -->
							<div class="d-flex align-items-center mt-2">
								<div ref="qrCodeContainer" class="qr-code-container mr-2">
									<img class="h-100 w-100" :src="getDetails.qrCode" alt="" />
								</div>
								<div class="candash-displaytxt-grey-3">
									Download and share profile QR
								</div>
								<div>
									<img
										@click="downloadQRCode"
										class="ml-2 pointer"
										src="@/assets/newdesign/dashboard/download2.svg"
										alt=""
									/>
								</div>
							</div>
						</div>
					</div>

					<div
						class="candash-below-header-2"
						:class="showAboutMe ? 'candash-padding-11' : 'candash-padding-12'"
					>
						<div class="p175 mobpl-0">
							<div
								class="d-flex flex-wrap mob-flex-column builder-mob-basicdetails"
							>
								<div class="candash-blackTxt d-flex align-items-center">
									<img
										class="mr-1"
										src="@/assets/newdesign/dashboard/dateOfBirth.svg"
										alt="dob"
									/>
									{{
										displayDateOfBirth(
											getDetails.dateOfBirth,
											getDetails.visibilityConfig.personalDetails_Fields
												.dateOfBirth
										)
									}}
								</div>

								<div
									class="candash-blackTxt mobml-0 word-break d-flex align-items-center"
								>
									<img
										class="mr-2"
										src="@/assets/newdesign/dashboard/blueMail.svg"
										alt=""
									/>
									{{
										maskedEmail(
											getDetails.displayEmail,
											getDetails.visibilityConfig.personalDetails_Fields
												.displayEmail
										)
									}}
								</div>

								<div
									class="candash-blackTxt mobml-0 d-flex align-items-center"
									v-if="getDetails.phoneNumber"
								>
									<img
										class="mr-1"
										src="@/assets/newdesign/dashboard/blueCall.svg"
										alt=""
									/>
									<span class="mobml-7px">
										{{
											maskedPhone(
												getDetails.phoneNumber,
												getDetails.visibilityConfig.personalDetails_Fields
													.phoneNumber
											)
										}}
									</span>
									<span v-if="getDetails.altPhoneNumber">
										,{{
											maskedPhone(
												getDetails.altPhoneNumber,
												getDetails.visibilityConfig.personalDetails_Fields
													.altPhoneNumber
											)
										}}
									</span>
								</div>

								<div
									class="candash-blackTxt mobml-0 vp-mb-10px d-flex align-items-center"
									v-if="getDetails.city"
								>
									<img
										class="mr-1"
										src="@/assets/newdesign/dashboard/blueLocation.svg"
										alt=""
									/>
									{{
										maskedCity(
											getDetails.city,
											getDetails.visibilityConfig.personalDetails_Fields.city
										)
									}},
									{{ getDetails.country }}
								</div>
							</div>
							<div class="d-flex align-items-center flex-wrap gap-2">
								<div
									class="portfolio-mob-box mt-2 mobmt-0 pointer"
									:class="
										!getDetails.visibilityConfig.personalDetails_Fields
											.portfolio
											? 'portfolio-card-blur'
											: ''
									"
									v-for="(portfolio, index) in displayPortfolio"
									:key="index + 'portf'"
									@click="openPortfolioLink(portfolio)"
								>
									<img :src="bindPortfolioSrc(portfolio)" class="mr-2" alt="" />
									{{ formatPortfolioLink(portfolio.portfolioLink) }}
								</div>
								<span
									v-if="hasMorePortfolio && !showAllPortfolios"
									@click="togglePortfolioView"
									class="pointer showmre-lesstxt mt-11px mobmt-0"
								>
									+{{ remainingPortfolioCount }} more
								</span>

								<span
									v-if="showAllPortfolios"
									@click="togglePortfolioView"
									class="pointer showmre-lesstxt mt-11px mobmt-0"
								>
									Show less
								</span>
								<!-- <span
									v-if="
										(localCandidateInfo.portfolio.length > 2 && !isLaptop) ||
										(localCandidateInfo.portfolio.length > 4 && isLaptop)
									"
								>
									+
									{{
										localCandidateInfo.portfolio.length > 2 && !isLaptop
											? localCandidateInfo.portfolio.length - 2
											: localCandidateInfo.portfolio.length - 4
									}}
									&nbsp; more
								</span> -->
							</div>
						</div>
						<div
							:class="
								getDetails.designation !== null && getDetails.designation !== ''
									? 'mt-3'
									: ''
							"
							v-if="showAboutMe"
						>
							<div class="candash-bold-black-txt-2 mobmt-85rem">About Me</div>
							<div
								class="candash-descrpth"
								v-if="
									getDetails.profileSummary &&
									getDetails.visibilityConfig.personalDetails_Fields
										.profileSummary
								"
							>
								{{ truncatedProfileSummary }}
								<span
									v-if="
										getDetails.profileSummary.length > 256 && !showFullContent
									"
								>
									...
								</span>
								<span
									v-if="
										getDetails.profileSummary.length > 256 && !showFullContent
									"
									class="pro-theme pointer fw-LM"
									@click="ProfileAboutToggle()"
								>
									show more
								</span>
								<span
									class="pro-theme pointer fw-LM"
									v-if="showFullContent"
									@click="ProfileAboutToggle()"
									>show less</span
								>
							</div>
							<div class="candash-descrpth word-break" v-else>
								{{ maskedProfileSummary }}
							</div>
						</div>
					</div>
				</div>
				<div class="mt-2">
					<div v-if="showTaskBarShimmer" class="candash-tabs-newcard mt-2">
						<div>
							<div>
								<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
							</div>
							<div class="demograpgic-data"></div>
							<div
								class="candash-blue-details-box mt-2 p-2"
								v-for="(j, index) in demographicsLoop"
								:key="index + 'demo-shim'"
							>
								<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
								<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>

								<b-skeleton class="mt-2 w-75 h-15"></b-skeleton>
							</div>
						</div>
					</div>
					<div
						v-else-if="
							!showTaskBarShimmer &&
							getDetails.educationalInfo == null &&
							!getDetails.visibilityConfig.education &&
							getDetails.sectionStatus.education
						"
						class="candash-tabs-newcard mt-2"
						:class="!getDetails.visibilityConfig.education ? 'card-blur' : ''"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<div class="candash-bold-black-txt-2">Education</div>
							</div>
						</div>

						<b-collapse v-model="openeducation">
							<div class="mb-4 demograpgic-data"></div>
							<div v-if="!getDetails.visibilityConfig.education" class="mt-2">
								<div
									class="d-flex align-items-start mt-2"
									v-for="(i, index) in loop"
									:key="index + 'educ'"
								>
									<div
										class="candash-blue-details-box d-flex align-items-start p-2"
									>
										<img
											class="mr-3"
											src="@/assets/newdesign/dashboard/eduDp.svg"
											alt=""
										/>
										<div class="w-100 d-flex justify-content-between">
											<div class="w85">
												<div class="bold-bluetxt">Loreal Ipsum</div>
												<div
													class="d-flex mt-2 align-items-center candash-displaytxt-grey-2 w-100"
												>
													<div class="max-w45 text-truncate">Loreal Ipsum</div>
													<div class="candash-dot ml-2 mr-2"></div>
													<div class="max-w35 text-truncate">Loreal Ipsum</div>
													<div class="candash-dot ml-2 mr-2"></div>
													<div>
														<span> Loreal Ipsum </span>
														<!-- <span v-else> ---- % </span> -->
													</div>
												</div>
												<div class="d-flex mt-2 align-items-center greytxt">
													<div class="max-w35 text-truncate">
														Loreal Ipsum
														<!-- <span v-else> currently studying </span> -->
													</div>
													<div class="candash-line ml-4 mr-4"></div>
													<div class="max-w35 text-truncate">Loreal Ipsum</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>
					<div
						v-else-if="
							!showTaskBarShimmer &&
							getDetails.visibilityConfig.education == true &&
							getDetails.educationalInfo &&
							getDetails.educationalInfo.length != 0
						"
						class="candash-tabs-newcard mt-2"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<div class="candash-bold-black-txt-2">Education</div>
							</div>
						</div>

						<b-collapse v-model="openeducation">
							<div class="mb-4 demograpgic-data"></div>
							<div
								v-for="(education, index) in getDetails.educationalInfo"
								:key="index + 'education'"
								class="mt-2"
							>
								<div class="d-flex align-items-start">
									<div
										class="candash-blue-details-box d-flex align-items-start p-2"
									>
										<img
											class="mr-3 lapicon"
											src="@/assets/newdesign/dashboard/eduDp.svg"
											alt=""
										/>
										<img
											class="mr-2 mobicon"
											src="@/assets/mobile/dashboard/mb-eduDP.svg"
											alt=""
										/>
										<div class="w-100 d-flex justify-content-between">
											<div class="w85 mob-w-95">
												<div class="bold-bluetxt">
													{{ education.institute }}
												</div>
												<div
													:class="isLaptop ? 'mt-2' : 'mt-1'"
													class="d-flex align-items-center candash-displaytxt-grey-2 fw-500"
												>
													<div class="mob-maxw-43 max-w45 text-truncate">
														{{ education.qualification }} (
														{{ education.courseDuration }}
														Year)
													</div>
													<template v-if="education.fieldOfStudy">
														<div class="candash-dot ml-2 mr-2"></div>
														<div class="mob-maxw-43 max-w35 text-truncate">
															{{ education.fieldOfStudy }}
														</div>
													</template>

													<template v-if="education.degree">
														<div class="candash-dot ml-2 mr-2"></div>
														<div class="mob-maxw-43 max-w35 text-truncate">
															{{ education.degree }}
														</div>
													</template>

													<div class="candash-dot ml-2 mr-2 hideinmob"></div>
													<div class="hideinmob">
														<span v-if="education.gradePercentage">
															{{ education.gradePercentage }}
															%</span
														>
														<span v-else> ---- % </span>
													</div>
												</div>
												<div
													class="w-100 text-truncate candash-displaytxt-grey-2 fw-500 mobile-breakdown-cgpa"
												>
													<span v-if="education.gradePercentage">
														{{ education.gradePercentage }}
														%
													</span>
												</div>
												<div
													:class="isLaptop ? ' mt-2 ' : ''"
													class="d-flex align-items-center greytxt"
												>
													<div class="max-w35 text-truncate">
														{{ formatMonthName(education.yearOfJoining) }}
														-
														<span v-if="education.yearOfPassout">
															{{ formatMonthName(education.yearOfPassout) }}
														</span>
														<span v-else> currently studying </span>
													</div>
													<div class="candash-line ml-4 mr-4"></div>
													<div class="mob-maxw-43 max-w35 text-truncate">
														{{ education.location }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>

					<div v-if="showTaskBarShimmer" class="candash-tabs-newcard mt-2">
						<div>
							<div>
								<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
							</div>
							<div class="demograpgic-data"></div>
							<div
								class="candash-blue-details-box mt-2 p-2"
								v-for="(j, index) in demographicsLoop"
								:key="index + 'exp-shim'"
							>
								<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
								<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>

								<b-skeleton class="mt-2 w-75 h-15"></b-skeleton>
							</div>
						</div>
					</div>
					<div
						v-else-if="
							!showTaskBarShimmer &&
							getDetails.visibilityConfig.experience == false &&
							getDetails.experience == null &&
							getDetails.sectionStatus.experience
						"
						class="candash-tabs-newcard mt-2"
						:class="
							getDetails.visibilityConfig.experience == false ? 'card-blur' : ''
						"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<div class="candash-bold-black-txt-2">Experience</div>
							</div>
						</div>
						<div v-if="getDetails.visibilityConfig.experience == false">
							<div
								v-for="(i, index) in loop"
								:key="index + 'experience'"
								class="mt-2"
							>
								<div class="d-flex align-items-start">
									<div class="candash-blue-details-box p-2">
										<div class="d-flex align-items-start">
											<img
												class="mr-3"
												src="@/assets/newdesign/dashboard/expDp.svg"
												alt=""
											/>
											<div class="w-100 d-flex justify-content-between">
												<div class="w85">
													<div class="bold-bluetxt">Loreal Ipsum</div>
													<div
														class="d-flex mt-2 align-items-center candash-displaytxt-grey-2"
													>
														<div class="max-w45 text-truncate">
															Loreal Ipsum
														</div>
														<div class="candash-dot ml-2 mr-2"></div>
														<div class="max-w45 text-truncate">
															Loreal Ipsum
														</div>
													</div>
													<div class="d-flex mt-2 align-items-center greytxt">
														<div class="max-w35 text-truncate">
															Loreal Ipsum
														</div>
														<div class="candash-line ml-4 mr-4"></div>
														<div class="max-w35 text-truncate">
															Loreal Ipsum
														</div>
													</div>
												</div>
											</div>
										</div>
										<div>
											<div class="candash-blackTxt mt-2">
												<ul class="candash-dotted-list">
													<li>Loreal Ipsum</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						v-else-if="
							!showTaskBarShimmer &&
							getDetails.visibilityConfig.experience == true &&
							getDetails.experience &&
							getDetails.experience.length != 0
						"
						class="candash-tabs-newcard mt-2"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<div class="candash-bold-black-txt-2">Experience</div>
							</div>
						</div>
						<div
							v-if="getDetails.experience && getDetails.experience.length != 0"
						>
							<div
								v-for="(experiencess, index) in getDetails.experience"
								:key="index + 'exp'"
								class="mt-2"
							>
								<div class="d-flex align-items-start">
									<div
										class="candash-blue-details-box p-2"
										@click="toggleShowMore(index)"
									>
										<div class="d-flex align-items-start">
											<img
												class="mr-3 lapicon"
												src="@/assets/newdesign/dashboard/expDp.svg"
												alt=""
											/>
											<img
												class="mr-2 mobicon"
												src="@/assets/mobile/dashboard/mb-expDP.svg"
												alt=""
											/>
											<div class="w-100 d-flex justify-content-between">
												<div class="w85">
													<div class="bold-bluetxt">
														{{ experiencess.designation }}
													</div>
													<div
														:class="isLaptop ? 'mt-2' : 'mt-1'"
														class="d-flex align-items-center candash-displaytxt-grey-2 fw-500"
													>
														<div class="mob-maxw-43 max-w45 text-truncate">
															{{ experiencess.companyName }}
														</div>
														<div class="candash-dot ml-2 mr-2"></div>
														<div class="mob-maxw-43 max-w45 text-truncate">
															{{ experiencess.jobType }}
														</div>
													</div>
													<div class="d-flex mt-2 align-items-center greytxt">
														<div class="max-w35 text-truncate">
															{{ formatMonthName(experiencess.startDate) }}
															-
															<template
																v-if="
																	experiencess.endDate !== '' &&
																	experiencess.endDate !== null
																"
															>
																{{ formatMonthName(experiencess.endDate) }}
															</template>
															<template v-else> Present </template>
														</div>
														<div class="candash-line ml-4 mr-4"></div>
														<div class="max-w35 text-truncate">
															{{ experiencess.location }}
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="mob-hide-exp">
											<div
												v-if="experiencess.highlight"
												class="candash-blackTxt mt-2"
											>
												<ul
													class="candash-dotted-list"
													v-for="(ress, ind) in experiencess.highlight.slice(
														0,
														showMoreHighlightsDesc[index]
															? experiencess.highlight.length
															: 1
													)"
													:key="ind + 'high'"
												>
													<li>
														{{ ress }}
													</li>
												</ul>
											</div>
											<span
												v-if="
													experiencess.highlight &&
													experiencess.highlight.length > 1 &&
													!showMoreHighlightsDesc[index]
												"
												class="pro-theme pointer"
												>show more</span
											>
											<span
												class="pro-theme pointer"
												v-if="
													showMoreHighlightsDesc[index] &&
													experiencess.highlight &&
													experiencess.highlight.length > 1
												"
												>show less</span
											>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div v-if="showTaskBarShimmer" class="candash-tabs-newcard mt-2">
						<div>
							<div>
								<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
							</div>
							<div class="demograpgic-data"></div>
							<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>

							<div
								class="candash-blue-details-box mt-2 p-2"
								v-for="(j, index) in demographicsLoop"
								:key="index + 'skill-shim'"
							>
								<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
								<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
							</div>
							<div class="demograpgic-data"></div>
							<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>

							<div
								class="candash-blue-details-box mt-2 p-2"
								v-for="(j, index) in demographicsLoop"
								:key="index + 'int-shim'"
							>
								<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
								<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
							</div>
						</div>
					</div>
					<div
						v-else-if="
							!showTaskBarShimmer &&
							getDetails.visibilityConfig.skills == false &&
							getDetails.skills == null &&
							getDetails.interpersonalSkills == null &&
							getDetails.sectionStatus.skills
						"
						class="candash-tabs-newcard mt-2"
						:class="
							getDetails.visibilityConfig.skills == false ? 'card-blur' : ''
						"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<div class="candash-bold-black-txt-2">Skills</div>
							</div>
						</div>

						<b-collapse v-model="openskill">
							<div v-if="getDetails.visibilityConfig.skills == false">
								<div
									class="d-flex align-items-start mt-2"
									v-for="(i, index) in loop"
									:key="index + 'skills-shim'"
								>
									<div
										class="candash-blue-details-box d-flex align-items-start p-2"
									>
										<img
											class="mr-3"
											src="@/assets/newdesign/dashboard/eduDp.svg"
											alt=""
										/>
										<div class="w-100 d-flex justify-content-between">
											<div class="w85">
												<div class="bold-bluetxt">Loreal Ipsum</div>
												<div
													class="d-flex mt-2 align-items-center candash-displaytxt-grey-2 w-100"
												>
													<div class="max-w45 text-truncate">Loreal Ipsum</div>
													<div class="candash-dot ml-2 mr-2"></div>
													<div class="max-w35 text-truncate">Loreal Ipsum</div>
													<div class="candash-dot ml-2 mr-2"></div>
													<div>
														<span> Loreal Ipsum </span>
														<!-- <span v-else> ---- % </span> -->
													</div>
												</div>
												<div class="d-flex mt-2 align-items-center greytxt">
													<div class="max-w35 text-truncate">
														Loreal Ipsum
														<!-- <span v-else> currently studying </span> -->
													</div>
													<div class="candash-line ml-4 mr-4"></div>
													<div class="max-w35 text-truncate">Loreal Ipsum</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>
					<div
						v-else-if="
							(!showTaskBarShimmer &&
								getDetails.visibilityConfig.skills == true &&
								isArrayNotEmpty(getDetails.skills)) ||
							isArrayNotEmpty(getDetails.interpersonalSkills)
						"
						class="candash-tabs-newcard mt-2"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<div class="candash-bold-black-txt-2">Skills</div>
							</div>
						</div>
						<b-collapse v-model="openskill">
							<div
								v-if="
									isArrayNotEmpty(getDetails.skills) ||
									isArrayNotEmpty(getDetails.interpersonalSkills)
								"
								class="mb-4 demograpgic-data"
							></div>
							<div class="candash-blktxt-bold">Technical Skills</div>

							<div
								v-for="(techSkill, ind) in getDetails.skills"
								:key="ind + 'techSkill'"
							>
								<div class="d-flex align-items-center mt-2">
									<div class="candash-blue-details-box d-flex p-2">
										<img
											class="mr-3 lapicon"
											src="@/assets/newdesign/dashboard/skillDp.svg"
											alt=""
										/>
										<img
											class="mr-2 mobicon"
											src="@/assets/newbuilder/mob-skills.svg"
											alt=""
										/>
										<div class="w-100 d-flex justify-content-between">
											<div class="w85">
												<div class="bold-bluetxt">
													{{ techSkill.skillName }}
												</div>
												<div
													class="d-flex mt-2 align-items-center candash-displaytxt-grey-2 mr-4"
												>
													<div>
														{{ techSkill.yearsOfExp }}
														<span
															v-if="
																techSkill.yearsOfExp !== null &&
																techSkill.yearsOfExp !== ''
															"
														>
															{{
																techSkill.yearsOfExp === 1 ? "Year" : "Years"
															}}
														</span>
													</div>

													<div class="candash-skillTag text-capitalize">
														{{ techSkill.expertiseLevel }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div
								v-if="getDetails.interpersonalSkills != null"
								class="candash-blktxt-bold"
								:class="!isArrayNotEmpty(getDetails.skills) ? 'mt-3' : 'mt-4'"
							>
								Interpersonal Skills
							</div>
							<div v-if="getDetails.interpersonalSkills != null">
								<div
									v-for="(skill, index) in getDetails.interpersonalSkills"
									:key="index + 'per-skills'"
								>
									<div class="d-flex align-items-center mt-2">
										<div class="candash-blue-details-box d-flex p-2">
											<img
												class="mr-3 lapicon"
												src="@/assets/newdesign/dashboard/skillDp.svg"
												alt=""
											/>
											<img
												class="mr-2 mobicon"
												src="@/assets/newbuilder/mob-skills.svg"
												alt=""
											/>
											<div class="w-100 d-flex justify-content-between">
												<div class="w85">
													<div class="bold-bluetxt">
														{{ skill.skillName }}
													</div>
													<div class="candash-skillTag text-capitalize mt-2">
														{{ skill.expertiseLevel }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div
								v-if="
									getDetails.hobbies != null && getDetails.sectionStatus.hobbies
								"
								class="candash-blktxt-bold"
								:class="!isArrayNotEmpty(getDetails.hobbies) ? 'mt-3' : 'mt-4'"
							>
								Interests / Hobbies
							</div>
							<div v-if="getDetails.hobbies != null">
								<div
									class="d-flex align-items-start mt-2"
									v-for="(hobbies, index) in getDetails.hobbies"
									:key="index + 'hobbies'"
								>
									<div class="candash-blue-details-box p-2">
										<div
											@click="openInsideProPortfolio = !openInsideProPortfolio"
											class="d-flex align-items-center pointer"
										>
											<img
												class="mr-3 lapicon"
												src="@/assets/newdesign/dashboard/skillDp.svg"
												alt=""
											/>
											<img
												class="mr-2 mobicon"
												src="@/assets/newbuilder/mob-skills.svg"
												alt=""
											/>
											<div
												class="w-100 d-flex align-items-center justify-content-between"
											>
												<div class="w85">
													<div class="bold-bluetxt mr-5">
														{{ hobbies }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>

					<div v-if="showTaskBarShimmer" class="candash-tabs-newcard mt-2">
						<div>
							<div>
								<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
							</div>
							<div class="demograpgic-data"></div>
							<div class="candash-blue-details-box mt-2 p-2">
								<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
								<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
							</div>
						</div>
					</div>

					<div
						v-else-if="
							!showTaskBarShimmer &&
							getDetails.visibilityConfig.project == false &&
							getDetails.projects == null &&
							getDetails.sectionStatus.project
						"
						class="candash-tabs-newcard mt-2"
						:class="
							getDetails.visibilityConfig.project == false ? 'card-blur' : ''
						"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<div class="candash-bold-black-txt-2">Project</div>
							</div>
						</div>

						<b-collapse v-model="openproject">
							<div class="mb-4 demograpgic-data"></div>
							<div v-if="getDetails.visibilityConfig.project == false">
								<div
									class="d-flex align-items-start mt-2"
									v-for="(i, index) in loop"
									:key="index + 'project-shim'"
								>
									<div
										class="candash-blue-details-box d-flex align-items-start p-2"
									>
										<img
											class="mr-3"
											src="@/assets/newdesign/dashboard/eduDp.svg"
											alt=""
										/>
										<div class="w-100 d-flex justify-content-between">
											<div class="w85">
												<div class="bold-bluetxt">Loreal Ipsum</div>
												<div
													class="d-flex mt-2 align-items-center candash-displaytxt-grey-2 w-100"
												>
													<div class="max-w45 text-truncate">Loreal Ipsum</div>
													<div class="candash-dot ml-2 mr-2"></div>
													<div class="max-w35 text-truncate">Loreal Ipsum</div>
													<div class="candash-dot ml-2 mr-2"></div>
													<div>
														<span> Loreal Ipsum </span>
														<!-- <span v-else> ---- % </span> -->
													</div>
												</div>
												<div class="d-flex mt-2 align-items-center greytxt">
													<div class="max-w35 text-truncate">
														Loreal Ipsum
														<!-- <span v-else> currently studying </span> -->
													</div>
													<div class="candash-line ml-4 mr-4"></div>
													<div class="max-w35 text-truncate">Loreal Ipsum</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>
					<div
						v-else-if="
							!showTaskBarShimmer &&
							getDetails.projects &&
							getDetails.projects.length != 0 &&
							getDetails.visibilityConfig.project == true
						"
						class="candash-tabs-newcard mt-2"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<div class="candash-bold-black-txt-2">Project</div>
							</div>
						</div>

						<b-collapse v-model="openproject">
							<div class="mb-4 demograpgic-data"></div>
							<div
								v-if="
									getDetails.visibilityConfig.project &&
									getDetails.projects != null
								"
							>
								<div
									v-for="(project, index) in getDetails.projects"
									:key="index + 'project'"
								>
									<div class="d-flex align-items-start mt-2">
										<div class="candash-blue-details-box p-2">
											<div
												@click="
													openInsideProProject[index] =
														!openInsideProProject[index]
												"
												class="d-flex pointer"
											>
												<img
													class="mr-3 lapicon"
													src="@/assets/newdesign/dashboard/projDp.svg"
													alt=""
												/>
												<img
													class="mr-2 mobicon"
													src="@/assets/newbuilder/mobproject.svg"
													alt=""
												/>
												<div class="w-100 d-flex justify-content-between">
													<div class="w85">
														<div
															:class="
																isLaptop
																	? ' '
																	: 'd-flex align-items-center justify-content-between mt-1'
															"
														>
															<div class="bold-bluetxt mr-5">
																{{ project.title }}
															</div>
															<div
																v-if="!openInsideProProject[index]"
																class="mobile-view-more-txt text-blue hideinlaptop"
																@click.stop="
																	openInsideProProject[index] =
																		!openInsideProProject[index]
																"
															>
																View more
																<img
																	class="ml-1 mobrotate-180"
																	src="@/assets/job-search-icons/mob-uparrow.svg"
																	alt=""
																/>
															</div>
														</div>
														<div
															class="d-flex mt-2 align-items-center js-description-font"
														>
															{{ formatDateString(project.startDate) }}
															-
															<span v-if="!project.currentProject">{{
																formatDateString(project.endDate)
															}}</span>
															<span v-else> Current</span>
														</div>
													</div>
													<div class="pt-2 pr-2 hideinmob">
														<img
															v-if="!openInsideProProject[index]"
															src="@/assets/newdesign/dashboard/whiteBlueDown.svg"
															alt=""
															class="pointer"
														/>
														<img
															v-else
															src="@/assets/newdesign/dashboard/whiteBlueUp.svg"
															alt=""
															class="pointer"
														/>
													</div>
												</div>
											</div>
											<b-collapse
												v-model="openInsideProProject[index]"
												class="pt-1 pl-2 pr-2 pb-2"
											>
												<div class="candash-blackTxt ml-60 mobml-0">
													{{ project.summary }}
												</div>
												<b-row class="mt-3">
													<b-col :cols="isLaptop ? '6' : '12'">
														<div class="mobflex mobmb-2">
															<div class="candash-displaytxt-grey">
																Project Role
															</div>
															<div
																class="candash-bold-grey mt-1 mobml-3 mobmt-0"
															>
																{{ project.role }}
															</div>
														</div>
													</b-col>
													<b-col
														:cols="isLaptop ? '3' : '6'"
														class=""
														v-if="project.domain"
													>
														<div class="mobflex">
															<div class="candash-displaytxt-grey">Domain</div>
															<div
																class="candash-bold-grey mt-1 text-break mobml-3 mobmt-0"
															>
																{{ project.domain }}
															</div>
														</div>
													</b-col>
													<b-col
														:cols="isLaptop ? '3' : '6'"
														class="mobpx-0"
														v-if="project.client"
													>
														<div class="mobflex">
															<div class="candash-displaytxt-grey">Client</div>
															<div
																class="candash-bold-grey mt-1 text-break mobml-3 mobmt-0"
															>
																{{ project.client }}
															</div>
														</div>
													</b-col>
												</b-row>
												<b-row class="mt-3">
													<b-col>
														<div class="d-flex flex-wrap">
															<div class="min-w40 mobw-100 mobmb-2 mr-4">
																<div class="candash-displaytxt-grey">
																	Skills Used
																</div>
																<div class="d-flex flex-wrap min-w40 max-w100">
																	<div
																		v-for="(
																			skill, index1
																		) in project.skillsUsed"
																		:key="index1 + 'skill'"
																		class="candash-skillTag-2 mt-1 mr-2 mb-2"
																	>
																		{{ skill }}
																	</div>
																</div>
															</div>
														</div>
													</b-col>
												</b-row>
												<b-row class="mt-3" v-if="project.description">
													<b-col>
														<div class="candash-displaytxt-grey">
															Description
														</div>
														<div
															v-if="project.description"
															class="candash-blackTxt mt-1"
														>
															{{
																truncatedProjectDescription(project.description)
															}}
															...
															<span
																v-if="
																	project.description.length > 256 &&
																	!showFullContent
																"
																class="pro-theme pointer"
																@click="showMore()"
																>show more</span
															>
															<span
																class="pro-theme pointer"
																v-if="showFullContent"
																@click="showLess()"
																>show less</span
															>
														</div>
													</b-col>
												</b-row>
												<b-row class="mt-3 mobmt-0">
													<b-col>
														<div class="candash-displaytxt-grey">
															Responsibility
														</div>
														<div
															v-if="project.responsibility"
															class="candash-blackTxt mt-1"
														>
															<ul
																class="candash-dotted-list"
																v-for="(
																	ress, ind
																) in project.responsibility.slice(
																	0,
																	showResponsibility[index]
																		? project.responsibility.length
																		: 1
																)"
																:key="ind + 'ress'"
															>
																<li>
																	{{ ress }}
																</li>
															</ul>
														</div>
														<span
															v-if="
																project.responsibility &&
																project.responsibility.length > 1 &&
																!showResponsibility[index]
															"
															class="pro-theme pointer"
															@click="showMoreProject(index)"
															>show more</span
														>
														<span
															class="pro-theme pointer"
															v-if="
																project.responsibility &&
																project.responsibility.length > 1 &&
																showResponsibility[index]
															"
															@click="showLessResponsibility(index)"
															>show less</span
														>
													</b-col>
												</b-row>
												<div
													@click.stop="
														openInsideProProject[index] =
															!openInsideProProject[index]
													"
													class="mobile-view-more-txt text-blue hideinlaptop w-100 d-flex justify-content-end"
												>
													View less
													<img
														class="ml-1"
														src="@/assets/job-search-icons/mob-uparrow.svg"
														alt=""
													/>
												</div>
											</b-collapse>
										</div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>

					<div v-if="showTaskBarShimmer" class="candash-tabs-newcard mt-2">
						<div>
							<div>
								<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
							</div>
							<div class="demograpgic-data"></div>
							<div class="candash-blue-details-box mt-2 p-2">
								<b-skeleton class="mt-2 w-25 h-15"></b-skeleton>
								<b-skeleton class="mt-2 w-50 h-15"></b-skeleton>
							</div>
						</div>
					</div>
					<div
						v-else-if="
							!showTaskBarShimmer &&
							getDetails.visibilityConfig.achievement == false &&
							getDetails.sectionStatus.achievement
						"
						class="candash-tabs-newcard mt-2"
						:class="
							getDetails.visibilityConfig.achievement == false &&
							getDetails.awards == null &&
							getDetails.achievement == null &&
							getDetails.events == null
								? 'card-blur'
								: ''
						"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<div class="candash-bold-black-txt-2">Achievement</div>
							</div>
						</div>

						<b-collapse v-model="openachiev">
							<div v-if="getDetails.visibilityConfig.achievement == false">
								<div
									class="d-flex align-items-start mt-2"
									v-for="(i, index) in loop"
									:key="index + 'achiev-shim'"
								>
									<div
										class="candash-blue-details-box d-flex align-items-start p-2"
									>
										<img
											class="mr-3"
											src="@/assets/newdesign/dashboard/eduDp.svg"
											alt=""
										/>
										<div class="w-100 d-flex justify-content-between">
											<div class="w85">
												<div class="bold-bluetxt">Loreal Ipsum</div>
												<div
													class="d-flex mt-2 align-items-center candash-displaytxt-grey-2 w-100"
												>
													<div class="max-w45 text-truncate">Loreal Ipsum</div>
													<div class="candash-dot ml-2 mr-2"></div>
													<div class="max-w35 text-truncate">Loreal Ipsum</div>
													<div class="candash-dot ml-2 mr-2"></div>
													<div>
														<span> Loreal Ipsum </span>
														<!-- <span v-else> ---- % </span> -->
													</div>
												</div>
												<div class="d-flex mt-2 align-items-center greytxt">
													<div class="max-w35 text-truncate">
														Loreal Ipsum
														<!-- <span v-else> currently studying </span> -->
													</div>
													<div class="candash-line ml-4 mr-4"></div>
													<div class="max-w35 text-truncate">Loreal Ipsum</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>

					<div
						v-else-if="
							!showTaskBarShimmer &&
							getDetails.visibilityConfig.achievement == true &&
							(isArrayNotEmpty(getDetails.awards) ||
								isArrayNotEmpty(getDetails.achievement) ||
								isArrayNotEmpty(getDetails.events))
						"
						class="candash-tabs-newcard mt-2"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<div class="candash-bold-black-txt-2">Achievement</div>
							</div>
						</div>

						<b-collapse v-model="openachiev">
							<div>
								<div
									v-if="
										isArrayNotEmpty(getDetails.awards) ||
										isArrayNotEmpty(getDetails.achievement) ||
										isArrayNotEmpty(getDetails.events)
									"
									class="mb-4 demograpgic-data"
								></div>
								<!-- For Awards -->
								<div
									v-if="isArrayNotEmpty(getDetails.awards)"
									class="candash-blktxt-bold"
								>
									Awards
								</div>

								<draggable tag="div" group="trueexpdata" class="pointer">
									<div
										v-for="(achievement, id) in getDetails.awards"
										:key="id + 'award'"
									>
										<div>
											<div class="d-flex align-items-start mt-2">
												<div class="candash-blue-details-box p-2">
													<div
														@click="
															openInsideProCerti[id] = !openInsideProCerti[id]
														"
														class="d-flex pointer"
													>
														<img
															class="mr-3 lapicon"
															src="@/assets/newdesign/dashboard/skillDp.svg"
															alt=""
														/>
														<img
															class="mr-2 mobicon"
															src="@/assets/newbuilder/mob-skills.svg"
															alt=""
														/>
														<div class="w-100 d-flex justify-content-between">
															<div class="w85">
																<div
																	:class="
																		isLaptop
																			? ' '
																			: 'd-flex align-items-center justify-content-between mt-1'
																	"
																>
																	<div
																		class="bold-bluetxt mr-1 mob-w-65 text-truncate"
																	>
																		{{ achievement.title }}
																	</div>
																	<div
																		v-if="!openInsideProCerti[id]"
																		@click.stop="
																			openInsideProCerti[id] =
																				!openInsideProCerti[id]
																		"
																		class="mobile-view-more-txt text-blue hideinlaptop"
																	>
																		View more
																		<img
																			class="ml-1 mobrotate-180"
																			src="@/assets/job-search-icons/mob-uparrow.svg"
																			alt=""
																		/>
																	</div>
																</div>
																<div
																	:class="isLaptop ? 'mt-2' : ''"
																	class="d-flex align-items-center js-description-font"
																>
																	{{ achievement.issuingOrganization }}
																</div>
															</div>
															<div class="pt-2 pr-2 hideinmob">
																<img
																	v-if="!openInsideProCerti[id]"
																	src="@/assets/newdesign/dashboard/whiteBlueDown.svg"
																	alt=""
																	class="pointer"
																/>
																<img
																	v-else
																	src="@/assets/newdesign/dashboard/whiteBlueUp.svg"
																	alt=""
																	class="pointer"
																/>
															</div>
														</div>
													</div>
													<b-collapse
														v-model="openInsideProCerti[id]"
														class="p-2"
													>
														<b-row class="mt-3">
															<b-col
																:cols="isLaptop ? '6' : '12'"
																class="mobmb-2"
															>
																<div class="candash-displaytxt-grey">
																	Issued Organization
																</div>
																<div class="candash-bold-grey mt-1">
																	{{ achievement.issuingOrganization }}
																</div>
															</b-col>
															<b-col :cols="isLaptop ? '2' : '4'">
																<div class="candash-displaytxt-grey">
																	Issued Date
																</div>
																<div class="candash-bold-grey mt-1">
																	{{
																		formatDate(
																			achievement.issueDate,
																			"dd-MM-yyyy"
																		)
																	}}
																</div>
															</b-col>
															<b-col
																:cols="isLaptop ? '2' : '4'"
																v-if="achievement.expirationDate"
															>
																<div class="candash-displaytxt-grey">
																	Expiry Date
																</div>
																<div class="candash-bold-grey mt-1">
																	{{
																		formatDate(
																			achievement.expirationDate,
																			"dd-MM-yyyy"
																		)
																	}}
																</div>
															</b-col>
														</b-row>
														<b-row class="mt-3">
															<b-col v-if="achievement.description != null">
																<div class="candash-displaytxt-grey">
																	Description
																</div>
																<div class="candash-blackTxt mt-1">
																	{{ achievement.description }}
																</div>
															</b-col>
														</b-row>
														<div
															@click.stop="
																openInsideProCerti[id] = !openInsideProCerti[id]
															"
															class="mobile-view-more-txt text-blue hideinlaptop w-100 d-flex justify-content-end"
														>
															View less
															<img
																class="ml-1"
																src="@/assets/job-search-icons/mob-uparrow.svg"
																alt=""
															/>
														</div>
													</b-collapse>
												</div>
											</div>
										</div>
									</div>
								</draggable>

								<!-- For certificates -->
								<div
									v-if="isArrayNotEmpty(getDetails.achievement)"
									class="candash-blktxt-bold mt-5"
								>
									Certificates
								</div>

								<draggable tag="div" group="trueexpdata" class="pointer">
									<div
										v-for="(achievement, id) in getDetails.achievement"
										:key="id + 'award'"
									>
										<div class="d-flex align-items-start mt-2">
											<div class="candash-blue-details-box p-2">
												<div
													@click="
														openInsideProAward[id] = !openInsideProAward[id]
													"
													class="d-flex pointer"
												>
													<img
														class="mr-3 lapicon"
														src="@/assets/newdesign/dashboard/skillDp.svg"
														alt=""
													/>
													<img
														class="mr-2 mobicon"
														src="@/assets/newbuilder/mob-skills.svg"
														alt=""
													/>
													<div class="w-100 d-flex justify-content-between">
														<div class="w85">
															<div
																:class="
																	isLaptop
																		? ' '
																		: 'd-flex align-items-center justify-content-between mt-1'
																"
															>
																<div
																	class="bold-bluetxt mr-1 mob-w-65 text-truncate"
																>
																	{{ achievement.title }}
																	<img
																		v-if="achievement.uploadFile != null"
																		class="ml-4 pointer"
																		src="@/assets/newdesign/dashboard/download (2).svg"
																		alt=""
																	/>
																</div>
																<div
																	v-if="!openInsideProAward[id]"
																	@click.stop="
																		openInsideProAward[id] =
																			!openInsideProAward[id]
																	"
																	class="mobile-view-more-txt text-blue hideinlaptop"
																>
																	View more
																	<img
																		class="ml-1 mobrotate-180"
																		src="@/assets/job-search-icons/mob-uparrow.svg"
																		alt=""
																	/>
																</div>
															</div>
															<div
																class="d-flex mt-2 align-items-center js-description-font"
															>
																{{ achievement.issuingOrganization }}
															</div>
														</div>
														<div class="pt-2 pr-2 hideinmob">
															<img
																v-if="!openInsideProAward[id]"
																src="@/assets/newdesign/dashboard/whiteBlueDown.svg"
																alt=""
																class="pointer blueShadow"
															/>
															<img
																v-else
																src="@/assets/newdesign/dashboard/whiteBlueUp.svg"
																alt=""
																class="pointer blueShadow"
															/>
														</div>
													</div>
												</div>
												<b-collapse
													v-model="openInsideProAward[id]"
													class="p-2"
												>
													<b-row class="mt-3">
														<b-col
															:cols="isLaptop ? '5' : '12'"
															class="mobmb-2"
														>
															<div class="candash-displaytxt-grey">
																Issued Organization
															</div>
															<div class="candash-bold-grey mt-1">
																{{ achievement.issuingOrganization }}
															</div>
														</b-col>
														<b-col :cols="isLaptop ? '2' : '4'">
															<div class="candash-displaytxt-grey">
																Issued Date
															</div>
															<div class="candash-bold-grey mt-1">
																{{
																	formatDate(
																		achievement.issueDate,
																		"dd-MM-yyyy"
																	)
																}}
															</div>
														</b-col>
														<b-col
															:cols="isLaptop ? '2' : '4'"
															v-if="achievement.expirationDate"
														>
															<div class="candash-displaytxt-grey">
																Expiry Date
															</div>
															<div class="candash-bold-grey mt-1">
																{{
																	formatDate(
																		achievement.expirationDate,
																		"dd-MM-yyyy"
																	)
																}}
															</div>
														</b-col>
														<b-col cols="3" v-if="achievement.certificationID">
															<div class="candash-displaytxt-grey">
																Certification ID
															</div>
															<div class="candash-bold-grey mt-1">
																{{ achievement.certificationID }}
															</div>
														</b-col>
													</b-row>
													<b-row class="mt-3">
														<b-col v-if="achievement.description != null">
															<div class="candash-displaytxt-grey">
																Description
															</div>
															<div class="candash-blackTxt mt-1">
																{{ achievement.description }}
															</div>
														</b-col>
													</b-row>
													<div
														class="mobile-view-more-txt text-blue hideinlaptop w-100 d-flex justify-content-end"
														@click.stop="
															openInsideProAward[id] = !openInsideProAward[id]
														"
													>
														View less
														<img
															class="ml-1"
															src="@/assets/job-search-icons/mob-uparrow.svg"
															alt=""
														/>
													</div>
												</b-collapse>
											</div>
										</div>
									</div>
								</draggable>

								<!-- For Events -->
								<div
									v-if="isArrayNotEmpty(getDetails.events)"
									class="candash-blktxt-bold"
									:class="
										(getDetails.awards && getDetails.awards.length > 0) ||
										(getDetails.achievement &&
											getDetails.achievement.length > 0)
											? 'mt-5'
											: 'mt-3'
									"
								>
									Events
								</div>

								<draggable tag="div" group="trueexpdata" class="pointer">
									<div
										v-for="(achievement, id) in getDetails.events"
										:key="id + 'achiev'"
									>
										<div class="d-flex align-items-start mt-2">
											<div class="candash-blue-details-box p-2">
												<div
													@click="
														openInsideProEvent[id] = !openInsideProEvent[id]
													"
													class="d-flex pointer"
												>
													<img
														class="mr-3 lapicon"
														src="@/assets/newdesign/dashboard/skillDp.svg"
														alt=""
													/>
													<img
														class="mr-2 mobicon"
														src="@/assets/newbuilder/mob-skills.svg"
														alt=""
													/>
													<div
														class="w-100 d-flex align-items-center justify-content-between"
													>
														<div class="w-100">
															<div
																:class="
																	isLaptop
																		? ' '
																		: 'd-flex align-items-center justify-content-between mt-1'
																"
															>
																<div
																	class="bold-bluetxt mr-1 mob-w-65 text-truncate"
																>
																	{{ achievement.title }}
																</div>
																<div
																	v-if="!openInsideProEvent[id]"
																	@click.stop="
																		openInsideProEvent[id] =
																			!openInsideProEvent[id]
																	"
																	class="mobile-view-more-txt text-blue hideinlaptop"
																>
																	View more
																	<img
																		class="ml-1 mobrotate-180"
																		src="@/assets/job-search-icons/mob-uparrow.svg"
																		alt=""
																	/>
																</div>
															</div>
															<div
																class="d-flex mt-2 align-items-center js-description-font"
															>
																{{ achievement.issuingOrganization }}
															</div>
														</div>

														<div
															class="pr-2 d-flex align-items-start hideinmob"
															v-if="achievement.description != null"
														>
															<img
																v-if="!openInsideProEvent[id]"
																src="@/assets/newdesign/dashboard/whiteBlueDown.svg"
																alt=""
																class="pointer blueShadow"
															/>
															<img
																v-else
																src="@/assets/newdesign/dashboard/whiteBlueUp.svg"
																alt=""
																class="pointer blueShadow"
															/>
														</div>
													</div>
												</div>
												<b-collapse
													v-model="openInsideProEvent[id]"
													:class="achievement.description != null ? 'p-2' : ''"
												>
													<b-row
														class="mt-3"
														v-if="achievement.description != null"
													>
														<b-col>
															<div class="candash-displaytxt-grey">
																Description
															</div>
															<div class="candash-blackTxt mt-1">
																{{ achievement.description }}
															</div>
														</b-col>
													</b-row>
													<div
														class="mobile-view-more-txt text-blue hideinlaptop w-100 d-flex justify-content-end"
														@click.stop="
															openInsideProEvent[id] = !openInsideProEvent[id]
														"
													>
														View less
														<img
															class="ml-1"
															src="@/assets/job-search-icons/mob-uparrow.svg"
															alt=""
														/>
													</div>
												</b-collapse>
											</div>
										</div>
									</div>
								</draggable>
							</div>
						</b-collapse>
					</div>

					<div v-if="showTaskBarShimmer" class="candash-tabs-newcard mt-2">
						<div>
							<div>
								<b-skeleton class="mt-2 w-15 h-15"></b-skeleton>
							</div>
							<div class="demograpgic-data"></div>

							<div class=" ">
								<div class="d-flex justify-content-center">
									<b-skeleton-img
										no-aspect
										height="300px "
										width="50%"
										class="mt-2"
										style="bottom: 3px; border-radius: 5px"
									></b-skeleton-img>
								</div>
							</div>
						</div>
					</div>
					<div
						class="candash-tabs-newcard mt-2"
						v-else-if="
							!showTaskBarShimmer &&
							getDetails.visibilityConfig.videoSnapshot == true &&
							getDetails.videoResume != null
						"
					>
						<span class="candash-bold-black-txt-2">Video Snapshot</span>

						<div
							class="d-flex align-items-center justify-content-center h93 w-100"
						>
							<div class="d-flex flex-column justify-content-center">
								<div
									class="sp-black-preview position-relative flipped-video-container"
								>
									<video
										v-if="getDetails.videoResume"
										:src="getDetails.videoResume"
										width="100%"
										height="100%"
										class="flipped-video"
										style="object-fit: unset; height: 100%; border-radius: 5px"
										controls
										controlsList="nodownload nofullscreen"
										:autoplay="false"
										:muted="false"
										:loop="false"
										ref="camera"
										disablePictureInPicture
									></video>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal
			v-model="showPublicHidden"
			id="paymentmodal"
			size="md"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			@hidden="showPublicHidden = false"
		>
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-body-3">
						<div class="payment-header position-relative">
							<div
								class="payment-header-txt d-flex align-items-center ml-3 h-100"
							>
								Profile's Public <br />visibility is hidden
							</div>
							<div class="payment-header-img">
								<img src="@/assets/icons/payments/headerimage.png" alt="" />
							</div>
						</div>
						<div class="mt-4 mb-3 text-center fs-16 fw-600 fc-20639b">
							This Content is Private and Not Visible to Others.
						</div>
						<div class="mb-4 text-center fs-14 fc-3a3c40">
							The candidate has chosen to keep this content private, so <br />
							the details are not accessible for viewing.
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import commonFunc from "@/components/mixin/commonFunction.js";
import NcdTopContainer from "@/components/NewCandidateDashboard/NcdTopContainer.vue";
import draggable from "vuedraggable";
import {
	getPublicProfileDetails,
	getCandInfo,
	getProfileCompletion,
	staticImage,
} from "../utils/apiFunctions";
import { mapGetters } from "vuex";
import { markPrerenderReady } from "../utils/prerender.js";

import {
	formatDate,
	formatMonthName,
} from "../controllers/dashboard/helpers.js";
import { hasAccess } from "@/utils/tokenCheck";

export default {
	name: "ViewProfile",
	components: {
		NcdTopContainer,
		draggable,
	},
	mixins: [commonFunc],
	data() {
		return {
			staticImageLink: null,
			incompletedatamodal: false,
			showPublicHidden: false,
			shareClick: false,
			linkCopied: false,
			showAllPortfolios: false,
			shouldShowIcon: false,
			candidateInfo: {},
			showResponsibility: [],
			videoResume: "",
			loop: 2,
			avatarText: "",
			openInsideProCerti: {},
			openInsideProAward: {},
			openInsideProEvent: {},
			openInsideProPortfolio: false,

			openInsideProProject: {},
			showMoreResponsibility: false,

			showFullContent: false,
			selectedTabOnCrud: null,
			showMoreHighlightsDesc: [],

			getDetails: {
				visibilityConfig: {},
			},
			oldProfile: true,
			openproject: true,
			showAboutMe: true,

			openskill: true,
			openexperience: true,
			openeducation: true,
			openachiev: true,
			opendemographic: true,

			videoSaved: false,
			showloader: false,
			timeLeftInSeconds: 120,
			showProgressBar: false,
			progressPercentage: 0,
			openPortfolio: true,

			shareClick: false,
			videoRecord: false,

			previewAts: false,
			storedResume: false,
			camera: false,
			VideoDevice: [],
			selectedCamera: "",
			selectedMic: "",
			speaker: false,
			selectedSpeaker: "",
			OutputDevice: [],
			toggle: false,
			disables: false,

			AudioDevice: [],
			mic: false,

			showTaskBarShimmer: false,
			demographicsLoop: 3,
		};
	},
	computed: {
		hasMorePortfolio() {
			const limit = this.isLaptop ? 4 : 2;
			return (
				this.getDetails.portfolio.length > limit && !this.showAllPortfolios
			);
		},
		remainingPortfolioCount() {
			const limit = this.isLaptop ? 4 : 2;
			return Math.max(0, this.getDetails.portfolio.length - limit);
		},
		displayPortfolio() {
			const limit = this.isLaptop ? 4 : 2;
			return this.showAllPortfolios
				? this.getDetails.portfolio
				: this.getDetails.portfolio.slice(0, limit);
		},
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
			token: "getToken",
		}),
		truncatedProfileSummary() {
			return this.showFullContent
				? this.getDetails.profileSummary
				: this.getDetails.profileSummary.slice(0, 256);
		},
		maskedProfileSummary() {
			const length = this.getDetails.profileSummary?.length || 256;
			return "x".repeat(length);
		},
	},
	//   mounted(){
	//     EventBus.$on("hideAboutMe", this.hideAboutMe);

	//     EventBus.$on("showAboutMeScroll", this.showAboutMeScroll);

	//   },
	async created() {
		console.log("my cont ");
		// if (this.token) {
		// 	this.getProfileName();
		// }
		// if (this.$route.params.username == this.userInfo.username) {
		// 	this.$router.push({
		// 		name: "CandidateDashboard",
		// 	});
		// 	console.log("heree");
		// } else {
		console.log("there");
		await this.getProfileDetails();
		markPrerenderReady();
		// }
	},

	methods: {
		hasAccess,
		openPortfolioLink(porfolio) {
			let link = porfolio.portfolioLink;
			const cleanedLink = link.replace(/^(https?:\/\/)?(www\.)?/, "");
			const finalLink = `https://www.${cleanedLink}`;
			window.open(finalLink, "_blank");
		},
		async getStaticImage() {
			try {
				let payload = this.getAvatarText();
				const response = await staticImage(payload);
				if (response.status === 200) {
					this.staticImageLink = response.data.data.link;
				}
			} catch (error) {
				console.error("Error:", error);
			}
		},
		getAvatarText() {
			const first = this.getDetails?.firstName?.charAt(0).toUpperCase() || "";
			const last = this.getDetails?.lastName?.charAt(0).toUpperCase() || "";
			return first + last;
		},
		maskText(text, isVisible = true) {
			if (isVisible || !text) return text;
			return "x".repeat(text.length);
		},
		maskExperience(years, isVisible = true) {
			if (isVisible || !years) return years;
			return "xx";
		},
		maskedCity(city, isVisible = true) {
			if (isVisible || !city) return city;

			return "x".repeat(city.length);
		},
		maskedPhone(number, isVisible = true) {
			if (isVisible || !number || number.includes("x")) return number;

			const digitsOnly = number.toString().replace(/\D/g, "");
			if (digitsOnly.length <= 2) return digitsOnly;

			return digitsOnly.slice(0, 2) + "x".repeat(digitsOnly.length - 2);
		},

		maskedEmail(email, isVisible = true) {
			if (isVisible || !email) return email;

			const [localPart, domain] = email.split("@");
			if (!localPart || !domain) return email;

			const maskedLocal = localPart[0] + "x".repeat(localPart.length - 1);
			return `${maskedLocal}@${domain}`;
		},
		maskName(name) {
			if (!name || typeof name !== "string") return "";
			return name.charAt(0) + "x".repeat(name.length - 1);
		},
		togglePortfolioView() {
			this.showAllPortfolios = !this.showAllPortfolios;
		},
		formatPortfolioLink(link) {
			let cleanedLink = link.includes("www.") ? link.split("www.")[1] : link;
			return cleanedLink.replace(/(\.[a-z]{3})\S*$/, "$1");
		},
		bindPortfolioSrc(portfolio) {
			if (portfolio.portfolioName == "dribbble") {
				return require("@/assets/newbuilder/dribble.svg");
			} else if (portfolio.portfolioName == "behance") {
				return require("@/assets/newbuilder/behance.svg");
			} else if (portfolio.portfolioName == "linkedIn") {
				return require("@/assets/newbuilder/linkedin.svg");
			} else {
				return require("@/assets/newbuilder/gitlab.svg");
			}
		},
		displayDateOfBirth(dateString, isVisible = true) {
			const months = [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December",
			];

			if (typeof dateString === "string" && dateString.includes("xxxx")) {
				return dateString;
			}

			const date = new Date(dateString);

			if (isNaN(date.getTime())) {
				return null; // Invalid date
			}

			const day = date.getDate(); // 1–31
			const monthName = months[date.getMonth()];
			const year = date.getFullYear();

			if (isVisible) {
				return `${monthName} ${day}, ${year}`;
			} else {
				return `xxxxxx ${day}, xxxx`;
			}
		},
		capitalizeFirstLetter(value) {
			if (!value) return "";
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
		closeShare() {
			this.shareClick = false;
			this.linkCopied = false;
		},
		async downloadQRCode() {
			const link = document.createElement("a");
			link.href = this.getDetails.qrCode;
			link.download = "qr_code.png"; // You can set the filename here
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		openShare() {
			this.shareClick = !this.shareClick;

			if (!this.shareClick) {
				this.linkCopied = false;
			}
		},
		copyTheLink(sharedLink) {
			this.$copyToClipboard(sharedLink);
			this.linkCopied = true;
		},
		async getProfileName() {
			try {
				const resp = await getCandInfo();
				if (resp.status == 200) {
					this.candidateInfo = resp.data.data;
					this.$store.commit(
						"candidateVUEX/setCandidateInfo",
						this.candidateInfo
					);
				}

				const res = await getProfileCompletion();
				if (res.status == 200) {
					const candProgress = res.data.data;
					this.$store.commit(
						"candidateVUEX/updateCandidateProgress",
						candProgress
					);
				} else {
					console.log("Error Api");
				}
			} catch (error) {}
		},
		truncatedProjectDescription(cont) {
			return this.showFullContent ? cont : cont.slice(0, 256);
		},
		showMore() {
			this.showFullContent = true;
		},
		showLess() {
			this.showFullContent = false;
		},
		showMoreProject(index) {
			this.$set(this.showResponsibility, index, true);
		},

		showLessResponsibility(index) {
			this.$set(this.showResponsibility, index, false);
		},
		toggleShowMore(index) {
			this.$set(
				this.showMoreHighlightsDesc,
				index,
				!this.showMoreHighlightsDesc[index]
			);
		},
		formatMonthName(inputDate) {
			return formatMonthName(inputDate);
		},
		formatDate(inputDate, format) {
			return formatDate(inputDate, format);
		},
		formatDateString(dateString) {
			const months = [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December",
			];

			const date = new Date(dateString);

			if (isNaN(date.getTime())) {
				// Invalid date
				return null;
			}

			const monthName = months[date.getMonth()];
			const year = date.getFullYear();

			return `${monthName} ${year}`;
		},
		async getProfileDetails() {
			this.showTaskBarShimmer = true;
			try {
				let payload = {
					username: this.$route.params.username,
					loggedIn: this.token ? true : false,
					// loggedIn: false,
				};
				const res = await getPublicProfileDetails(payload);
				console.log(res.status);
				if (res.status == 200) {
					this.showTaskBarShimmer = false;
					this.getDetails = res.data.data;
					for (let key in this.getDetails.visibilityConfig) {
						if (this.getDetails.visibilityConfig[key] !== false) {
							this.showPublicHidden = false;
							break;
						}
						this.showPublicHidden = true;
					}

					if (
						this.getDetails.nationality == null &&
						this.getDetails.dateOfBirth == null &&
						this.getDetails.languages &&
						this.getDetails.languages.length == 0 &&
						this.getDetails.city == null &&
						this.getDetails.industry == null &&
						this.getDetails.experienceLevel == null
					) {
						this.incompletedatamodal = true;
					}

					if (
						!this.getDetails.image ||
						(this.getDetails.visibilityConfig?.personalDetails_Fields &&
							!this.getDetails.visibilityConfig.personalDetails_Fields.image)
					) {
						this.getStaticImage();
					}
				} else if (
					res.status == 204 ||
					res.status == 404 ||
					res.status == 410
				) {
					this.$router.push({
						name: "AccountDisabled",
					});
				}
			} catch (error) {
				console.error("Error fetching public profile details:", error);

				if (error.response.status == 404 || error.response.status == 410) {
					this.$router.push({
						name: "AccountDisabled",
					});
				} else {
					this.$router.push({
						path: "/404",
					});
				}

				// Handle the error as needed
			}
		},
		ProfileAboutToggle() {
			this.showFullContent = !this.showFullContent;
		},

		showAboutMeScroll() {
			this.showAboutMe = true;
		},

		hideAboutMe() {
			this.showAboutMe = false;
		},
		isArrayNotEmpty(arr) {
			return Array.isArray(arr) && arr.length > 0;
		},
	},
};
</script>

<style scoped>
.portfolio-card-blur {
	filter: blur(1px);
	user-select: none;
	pointer-events: none;
}
@media (max-width: 1028px) {
	.mob-top-0 {
		top: 0px;
	}
	#mobileheader {
		display: flex;
		height: 60px;
	}
	.profile-candash-left-container {
		width: 100%;
	}
	.mob-shareicon {
		position: absolute !important;
		right: 3px;
		bottom: 5px;
	}
	.public-sharelink-box {
		width: 300px;
		right: 4px;
		top: 2px;
	}
	.mob-w-65 {
		width: 65%;
	}
	.mobmt-85rem {
		margin-top: 0.85rem;
	}
	.mobml-7px {
		margin-left: 7px;
	}
	.profile-candash-left-container {
		padding-right: 0;
	}
	.vp-mb-10px {
		margin-bottom: 10px;
	}
}
</style>
